import { Observable } from 'rx';
import _ from 'lodash';

/**
 * We couldn't use table rows becase we cannot do CSS animations on them.
 * Header row contains cells as HTML div tags.
 * On every window resize we should calculate cell width.
 * @param  {number} debounce Debounce time in MS. Defaults to 100ms.
 * @return {RxJS.Observable}
 */
export function calculateCellWidths({debounce = 100}) {
  return Observable.fromEvent(window, 'resize')
    .debounce(debounce)
    .filter((event) => typeof document.getElementsByClassName('row')[1] !== 'undefined')
    .map((event) => _.map(
      document.getElementsByClassName('row')[1].getElementsByClassName('cell'),
      (cell) => parseFloat(window.getComputedStyle(cell).width)
    ));
}



// WEBPACK FOOTER //
// ./streams/calculateCellWidths.js